import React from "react"
//import I18n from "i18n-js/index.js.erb"
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import EmailCampaignPresenterNavSteps from "./EmailCampaignPresenterNavSteps"
import EmailCampaignPresenterWorkspace from "./EmailCampaignPresenterWorkspace"


export default class EmailCampaignPresenter extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      step: 'general',
      allowStepNavigation: false,
      loading: false,
      email_campaign: this.props.email_campaign,
      all_emails: this.props.all_emails,
      emailFields: this.props.email_fields || {},
      emailTriggers: this.props.email_triggers,
      allCustomerFields: this.props.all_customer_fields,
      customerFields: this.props.customer_fields || {},
      customerSelectBoxes: [],
      emailSelectBoxes: [],
      customers: this.props.customers,
      table_data: this.props.table_data || []
    };
  };

  componentDidMount() {
    var self = this
    var customerSelectBoxes = []
    var emailSelectBoxes = []

    if (Object.keys(self.state.customerFields).length > 0) {
      Object.keys(self.state.customerFields).map(function (key, index) {
        var obj = {}

        if (self.state.customerFields[key].additional_question) {
          obj.additional_question_value = key
          obj.value = I18n.t("customer_fields")
        } else {
          obj.value = key
        }

        obj.id = "select" + index
        customerSelectBoxes.push(obj)
      });
    }

    if (Object.keys(self.state.emailFields).length > 0) {
      Object.keys(self.state.emailFields).map(function (key, index) {
        var obj = {}

        obj.value = key
        obj.id = "select" + index

        emailSelectBoxes.push(obj)
      });
    }

    self.setState({customerSelectBoxes: customerSelectBoxes, emailSelectBoxes: emailSelectBoxes})
  }

  render(){
    var buttons = this.setButtons();
    return(
      <div className="EmailCampaignPresenter">
        <div className="panel panel-form">
          <LoadingSpinner show={this.state.loading} />
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <EmailCampaignPresenterNavSteps {...this.state}/>
          <EmailCampaignPresenterWorkspace {...this.state}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
          />
        </div>
      </div>
    )
  };

  //////// Helpers /////////

  setButtons(){
    if (this.state.step === 'customers_preview') {
      return [
        {
          name: I18n.t('prev'),
          button_classes: ['primary'],
          onClick: (e) => {
            this.stepBack()
            return false;
          },
        },
        {
          name: I18n.t('ok'),
          button_classes: ['primary'],
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },
      ];
    } else if (this.state.step === 'general'){
      return [
        {
          name: I18n.t('prev'),
          button_classes: ['primary'],
          html_attributes: [
            'disabled'
          ],
          onClick: (e) => {
            // this.stepBack()
            return false;
          },
        },
        {
          name: I18n.t('next'),
          button_classes: ['primary'],
          onClick: (e) => {
            this.validateStep()
            return false;
          },
        },
      ];
    } else {
      return [
        {
          name: I18n.t('prev'),
          button_classes: ['primary'],
          onClick: (e) => {
            this.stepBack()
            return false;
          },
        },
        {
          name: I18n.t('next'),
          button_classes: ['primary'],
          onClick: (e) => {
            this.validateStep()
            return false;
          },
        },
      ];
    };
  };

  stepBack(){
    if (this.state.step === 'customers_preview'){
      this.setState({ step: 'email_templates' })
    } else if (this.state.step === 'email_templates'){
      this.setState({ step: 'customer_details' })
    } else if (this.state.step === 'customer_details'){
      this.setState({ step: 'general' })
    }
  };

  setParams(){
    var params = this.state.email_campaign

    params.emails = this.state.emails
    params.customer_fields = this.state.customerFields
    params.email_fields = this.state.emailFields

    return params
  };

  ////// Ajax /////

  validateStep() {
    this.setState({loading: true});
    var params = this.setParams();

    if(this.state.step != "email_templates") {
      if (this.state.step === 'general') {
        this.setState({ step: 'customer_details', errors: [], loading: false });
      } else if (this.state.step === 'customer_details') {
        this.setState({ step: 'email_templates', errors: [], loading: false })
      }

      return null
    }

    $.ajax({
      type: 'POST',
      url: `/admin/email_campaigns/validate-step`,
      data: {
        email_campaign: params,
        customerSelectBoxes: this.state.customerSelectBoxes,
        emailSelectBoxes: this.state.emailSelectBoxes,
        step: this.state.step,
      }
    }).done((data) => {
      if(this.state.step === 'email_templates'){
        this.setState({step: 'customers_preview', errors: [], loading: false, customers: data.customers, table_data: data.table_data})
      }
    });
  };
};
